import useLanguageChange from "../../../../hooks/useLanguageChange";
import { isNull } from "lodash";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import { formatSessionID } from "../../../../shared/function";
import { ENABLED, NQ_UNSTABLE_PARAM } from "../../../../constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import useGetNetworkQuality from "../../../../hooks/useGetNetworkQuality";
import { setIsInviteModalOpen } from "../../../../reducers/invite-reducer";
import clsx from "clsx";

const MobileSessionInfo = () => {
    const dispatch = useDispatch();
    const { callDuration, isRoomConnected, timerStarted, isMobileSessionInfoVisible, nqAvailable } = useSelector((state) => state.commonReducer);
    const { localUserNetworkQuality } = useSelector((state) => state.twilioEvents);
    const { isOfflineModeActive } = useSelector((state) => state.offlineMode);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();
    const localUserQualityValue = useGetNetworkQuality();

    return (
        <>
            {((isRoomConnected && isMobileSessionInfoVisible) || isOfflineModeActive) && (
                <div className='mobile-topbar'>
                    <div className={clsx("mobile-topbar-in", isOfflineModeActive && "justify-content-center")}>
                        {!isOfflineModeActive && (
                            <div className='mobile-topbar-left'>{timerStarted && <div className='call-timer'>{callDuration}</div>}</div>
                        )}
                        <div className='mobile-topbar-middle'>
                            <div className='session-id'>
                                <span className='for-label'>{localisedValues["code"]}: </span>
                                {GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag.ONGOINGCALLINVITE === ENABLED ? (
                                    <button className='btn for-id' onClick={() => dispatch(setIsInviteModalOpen(true))}>
                                        {formatSessionID(GLOBAL_MEETING_DATA.sessionId)}
                                    </button>
                                ) : (
                                    <span>{formatSessionID(GLOBAL_MEETING_DATA.sessionId)}</span>
                                )}
                            </div>
                        </div>
                        {!isOfflineModeActive && (
                            <div className='mobile-topbar-right'>
                                <div className='device-info'>
                                    {nqAvailable && (
                                        <div className='session-network'>
                                            {isNull(localUserNetworkQuality) && <span className='for-close-icon icon-close'></span>}
                                            <div className='for-base-icon'>
                                                <span className='for-icon icon-network'></span>
                                            </div>
                                            {localUserNetworkQuality >= NQ_UNSTABLE_PARAM && (
                                                <div className='for-over-icon'>
                                                    <span
                                                        className='for-icon icon-network'
                                                        style={{ width: localUserQualityValue?.percentage || "0%" }}
                                                    ></span>
                                                </div>
                                            )}
                                            {!isNull(localUserNetworkQuality) && localUserNetworkQuality < NQ_UNSTABLE_PARAM && (
                                                <div className='for-over-icon'>
                                                    <span className='for-icon icon-network danger-text'></span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <div className='device-info-text'>{localisedValues.you}</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default MobileSessionInfo;
